import { render, staticRenderFns } from "./wontCreateCompany.vue?vue&type=template&id=7c47ba64&scoped=true"
import script from "./wontCreateCompany.vue?vue&type=script&lang=js"
export * from "./wontCreateCompany.vue?vue&type=script&lang=js"
import style0 from "./wontCreateCompany.vue?vue&type=style&index=0&id=7c47ba64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47ba64",
  null
  
)

export default component.exports